// extracted by mini-css-extract-plugin
module.exports = {"container":"photoModal_container__0nQ7A","close":"photoModal_close__aREi6","title":"photoModal_title__pHECE","overlay":"photoModal_overlay__KSFGM"};